import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import "./heroArea.scss"
import { DoubleArrow } from '@mui/icons-material';
import heroImg from "../../../images/hero-1.png"
import { Typewriter } from 'react-simple-typewriter'

import { NavLink } from "react-router-dom"


const HeroArea = () => {
    return (
        <div id="heroArea" className="hero-area">
            <Container>
                <Row className="align-items-center">
                    <Col lg={6}>
                        <div className="hero-left">

                            <h1 style={{ color: '#ffcb00', fontWeight: 'bold' }}>
                                {/* Style will be inherited from the parent element */}
                                <Typewriter
                                    words={[' অফিস অ্যাপ্লিকেশন', 'HCT ICT with Sanjoy Sir', 'ওয়েব ডিজাইন', 'ওয়েব ডেভেলপমেন্ট']}
                                    loop
                                    cursor
                                    cursorStyle='_'
                                    typeSpeed={70}
                                    deleteSpeed={50}
                                    delaySpeed={1000}
                                />
                            </h1>
                            <h2> কোর্স করে  প্রযুক্তির হাত ধরে এগিয়ে যাওয়ার প্রত্যয়ে </h2>
                            <p>এডভান্সড আইটি তোমাকে ভবিষ্যতের জন্য দক্ষ করে গড়ে তোলে এবং ক্যারিয়ার দৌঁড়ে অনেক প্রতিযোগী থেকে এগিয়ে রাখে।</p>
                            <NavLink className="c-btn btn-round-02" to="/reg">Registration <DoubleArrow /></NavLink>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="hero-right">
                            <div className="hero-img">
                                <img src={heroImg} alt="Image not found " />
                            </div>
                        </div>

                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default HeroArea;